import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { getRoleLabel } from '../../auth/roles';
import { USER_ROLES } from '../../types/user';
import './DashboardLayout.css';

function DashboardLayout() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  if (!currentUser) {
    return <div className="dashboard-route-status" role="status">Loading account...</div>;
  }

  const handleLogout = async () => {
    try {
      await logout();
    } catch {
      // Local authentication state is cleared even if the server is unreachable.
    } finally {
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="dashboard-shell">
      <aside className="dashboard-sidebar">
        <Link to="/" className="dashboard-brand">
          <img src="/strata_logo.png" alt="Strata Software Group" />
        </Link>
        <nav className="dashboard-nav" aria-label="Dashboard">
          <NavLink end to="/dashboard">Overview</NavLink>
          <NavLink to="/dashboard/projects">Projects</NavLink>
          {currentUser.role === USER_ROLES.ADMIN && <NavLink to="/dashboard/requests">Requests</NavLink>}
          {currentUser.role === USER_ROLES.ADMIN && <NavLink to="/dashboard/users">Users</NavLink>}
          <NavLink to="/dashboard/settings">Settings</NavLink>
        </nav>
      </aside>
      <div className="dashboard-main">
        <header className="dashboard-topbar">
          <div>
            <p className="eyebrow">{getRoleLabel(currentUser.role)}</p>
            <h1>{currentUser.name}</h1>
          </div>
          <button type="button" className="text-button" onClick={handleLogout}>
            Sign out
          </button>
        </header>
        <Outlet />
      </div>
    </div>
  );
}

export default DashboardLayout;
